import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { APPCONFIG } from './config'
import { LayoutService } from './layout/layout.service'

// 3rd
import 'styles/font-awesome.scss';
import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';

// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';

import { AdalService } from './shared/adal.service';
@Component({
    selector: 'my-app',
    template: require('./app.component.html'),
    providers: [LayoutService],
})
export class AppComponent {
    AppConfig: Object;
    constructor(private router: Router,private adalSvc: AdalService) {      
        
    }
    ngOnInit() {
    
        this.AppConfig = APPCONFIG;
        this.adalSvc.handleCallback();   
        // Scroll to top on route change
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            document.body.scrollTop = 0;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts